module.exports = __webpack_public_path__ + "media/images/static/line/minute_mobile-d948f68fdcf6da919fe9f8e9bb3be0fe.png";